module.exports = __webpack_public_path__ + "img/say-hello-chris.389d3c4f.jpg";